"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbar = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Lock_1 = __importDefault(require("@material-ui/icons/Lock"));
const Refresh_1 = __importDefault(require("@material-ui/icons/Refresh"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Share_1 = __importDefault(require("@material-ui/icons/Share"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const PlaylistAddCheck_1 = __importDefault(require("@material-ui/icons/PlaylistAddCheck"));
const AddBoxOutlined_1 = __importDefault(require("@material-ui/icons/AddBoxOutlined"));
const EditOutlined_1 = __importDefault(require("@material-ui/icons/EditOutlined"));
const DeleteOutlined_1 = __importDefault(require("@material-ui/icons/DeleteOutlined"));
const Person_1 = __importDefault(require("@material-ui/icons/Person"));
const LockOpen_1 = __importDefault(require("@material-ui/icons/LockOpen"));
const Print_1 = __importDefault(require("@material-ui/icons/Print"));
const Save_1 = __importDefault(require("@material-ui/icons/Save"));
const Undo_1 = __importDefault(require("@material-ui/icons/Undo"));
const Portal_1 = __importDefault(require("@material-ui/core/Portal"));
const Update_1 = __importDefault(require("@material-ui/icons/Update"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const user_context_1 = require("../../common/user/user-context");
const confirm_dialog_1 = require("../confirm-dialog/confirm-dialog");
const share_dialog_1 = require("../share-dialog/share-dialog");
const detail_toolbar_button_2_1 = require("./detail-toolbar-button-2");
const detail_context_1 = require("./detail-context");
const detail_types_1 = require("./detail-types");
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
const table_toolbar_button_1 = require("../table/table-toolbar-button");
const countdown_1 = require("../../components/countdown/countdown");
const tooltip_1 = require("../../components/tooltip/tooltip");
const split_screen_types_1 = require("../../components/split-screen/split-screen-types");
const table_context_1 = require("../table/table-context");
const table_styles_1 = require("../table/table-styles");
const evidence_context_1 = require("../evidence/evidence-context");
exports.useStyles = makeStyles_1.default({
    header: {
        boxShadow: '0px 0px 10px #ccc',
        zIndex: 98,
    },
    title: {
        margin: 10,
        fontSize: 25,
        fontWeight: 500,
    },
    subTitle: {
        marginLeft: 30,
        fontSize: 16,
    },
    toolbarWrapper: {
        backgroundColor: '#fafafa',
        paddingLeft: 10,
        paddingRight: 10,
        display: 'flex',
        zIndex: 99,
        justifyContent: 'space-between',
    },
    toolbar: {
        display: 'flex',
        flex: '0 0 auto',
    },
    actionbarWrapper: {
        backgroundColor: '#fafafa',
        padding: '6px 4px',
        display: 'flex',
        flex: '0 0 auto',
        width: '100%',
        overflowX: 'auto',
    },
    lockIcon: {
        width: 80,
        height: 49,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
function DetailToolbar({ title, subtitle, showBtn = lodash_1.stubTrue, disableBtn = lodash_1.stubFalse, ActionBar, Before, After, NewButton, RefreshButton, ShareButton, EditButton, CheckButton, SaveButton, CloseButton, RemoveButton, ExportButton, }) {
    var _a, _b;
    /**
     * Styles
     */
    const classes = exports.useStyles();
    const { mode, source, refresh, startNew, startEditing, cancelEditing, validate, del, save, isLocked, openExportDialog, reportTag, entityLocking, } = react_1.useContext(detail_context_1.DetailContext);
    const defaults = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const { user } = react_1.useContext(user_context_1.UserContext);
    const { splitScreenRef } = react_1.useContext(evidence_context_1.EvidenceContext);
    const countdownRef = react_1.useRef(null);
    const { enabled: enabledEntityLocking, lockedByUser, lockExpiration, keepLockAlive, remindLockExpiration, expirationReminderTime, forceUnlockEntity, } = entityLocking || {};
    const lockedByAnotherUser = lockedByUser !== undefined && lockedByUser !== user.id;
    const lockedByMe = lockedByUser !== undefined &&
        lockedByUser === user.id &&
        mode !== detail_types_1.DetailMode.EDIT;
    const DetailToolbarButtonComponent = (_a = defaults.ToolbarButtonComponent) !== null && _a !== void 0 ? _a : detail_toolbar_button_2_1.DetailToolbarButton;
    /**
     * Confirm deletion dialog / Share dialog.
     */
    const confirmDeleteDialog = react_1.useRef(null);
    const shareDeleteDialog = react_1.useRef(null);
    const handleDelete = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = confirmDeleteDialog.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const handleShare = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = shareDeleteDialog.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const handleNew = event_callback_hook_1.useEventCallback(() => {
        var _a, _b;
        const isFullscreenTable = (_a = splitScreenRef.current) === null || _a === void 0 ? void 0 : _a.isLeftOnFullscreen();
        if (isFullscreenTable) {
            (_b = splitScreenRef.current) === null || _b === void 0 ? void 0 : _b.handleMoveToMiddle();
            setTimeout(() => {
                startNew();
            }, 500);
        }
        else {
            startNew();
        }
    });
    const isModeNew = mode === detail_types_1.DetailMode.NEW;
    const isModeEdit = mode === detail_types_1.DetailMode.EDIT;
    const isModeNone = mode === detail_types_1.DetailMode.NONE;
    const isModeView = mode === detail_types_1.DetailMode.VIEW;
    const showNew = showBtn === null || showBtn === void 0 ? void 0 : showBtn('NEW');
    const disabledNew = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('NEW')) || isModeNew || isModeEdit;
    const NewButtonComponent = NewButton !== null && NewButton !== void 0 ? NewButton : DetailToolbarButtonComponent;
    const showRefresh = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('REFRESH')) && !isModeNone;
    const disabledRefresh = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('REFRESH')) || !isModeView;
    const RefreshButtonComponent = RefreshButton !== null && RefreshButton !== void 0 ? RefreshButton : DetailToolbarButtonComponent;
    const showShare = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('SHARE')) && !isModeNone;
    const disabledShare = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('SHARE')) || !isModeView;
    const ShareButtonComponent = ShareButton !== null && ShareButton !== void 0 ? ShareButton : DetailToolbarButtonComponent;
    const showEdit = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('EDIT')) && !isModeNone;
    const disabledEdit = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('EDIT')) ||
        !isModeView ||
        isLocked ||
        lockedByAnotherUser ||
        lockedByMe ||
        ((_b = source.data) === null || _b === void 0 ? void 0 : _b.active) === false;
    const EditButtonComponent = EditButton !== null && EditButton !== void 0 ? EditButton : DetailToolbarButtonComponent;
    const showCheck = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('CHECK')) && !isModeNone;
    const disabledCheck = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('CHECK')) || isModeNone || isModeView;
    const CheckButtonComponent = CheckButton !== null && CheckButton !== void 0 ? CheckButton : DetailToolbarButtonComponent;
    const showSave = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('SAVE')) && !isModeNone;
    const disabledSave = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('SAVE')) || isModeNone || isModeView;
    const SaveButtonComponent = SaveButton !== null && SaveButton !== void 0 ? SaveButton : DetailToolbarButtonComponent;
    const showClose = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('CLOSE')) && !isModeNone;
    const disabledClose = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('CLOSE')) || isModeNone || isModeView;
    const CloseButtonComponent = CloseButton !== null && CloseButton !== void 0 ? CloseButton : DetailToolbarButtonComponent;
    const showRemove = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('REMOVE')) && !isModeNone;
    const disabledRemove = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('REMOVE')) ||
        !isModeView ||
        isLocked ||
        lockedByAnotherUser ||
        lockedByMe;
    const RemoveButtonComponent = RemoveButton !== null && RemoveButton !== void 0 ? RemoveButton : DetailToolbarButtonComponent;
    const showExport = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('EXPORT')) && !isModeNone && reportTag;
    const disabledExport = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('EXPORT')) ||
        !isModeView ||
        isLocked ||
        lockedByAnotherUser ||
        lockedByMe;
    const ExportButtonComponent = ExportButton !== null && ExportButton !== void 0 ? ExportButton : DetailToolbarButtonComponent;
    const showUnlock = enabledEntityLocking &&
        lockedByAnotherUser &&
        forceUnlockEntity !== undefined;
    const isLockedByMe = enabledEntityLocking && lockedByMe;
    const isLockedByAnotherUser = enabledEntityLocking && lockedByAnotherUser;
    const showCountdown = enabledEntityLocking && mode === detail_types_1.DetailMode.EDIT;
    const titleText = react_1.useMemo(() => {
        if (title) {
            return typeof title === 'string'
                ? title
                : typeof title === 'function'
                    ? title(source.data)
                    : '';
        }
        return '';
    }, [source.data]);
    const subtitleText = react_1.useMemo(() => {
        if (subtitle) {
            return typeof subtitle === 'string'
                ? subtitle
                : typeof subtitle === 'function'
                    ? subtitle(source.data)
                    : '';
        }
        return '';
    }, [source.data]);
    /**
     * Display NEW button in detail-toolbar / table-toolbar based on SplitScreen default settings.
     */
    const AddButton = () => {
        const classes = table_styles_1.useStyles();
        const detailToolbarButton = (react_1.default.createElement(Portal_1.default, { container: document.getElementById('detail-toolbar') }, showNew && (react_1.default.createElement(NewButtonComponent, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__NEW", defaultMessage: "Nov\u00FD" }), startIcon: react_1.default.createElement(AddBoxOutlined_1.default, null), disabled: disabledNew, onClick: handleNew, type: detail_types_1.DetailToolbarButtonType.PRIMARY }))));
        const tableToolbarButton = (react_1.default.createElement(Portal_1.default, { container: document.getElementById('table-toolbar') }, showNew && (react_1.default.createElement(table_context_1.TableContext.Provider, { value: { classes } },
            react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { label: react_1.default.createElement(AddBoxOutlined_1.default, null), disabled: disabledNew, onClick: handleNew, primary: true, tooltip: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_TOOLBAR_BTN_NEW", defaultMessage: "Nov\u00FD" }) })))));
        return defaults.splitScreen === split_screen_types_1.SplitScreenMode.LEFT
            ? tableToolbarButton
            : detailToolbarButton;
    };
    react_1.useEffect(() => {
        var _a;
        if (enabledEntityLocking && lockExpiration) {
            (_a = countdownRef === null || countdownRef === void 0 ? void 0 : countdownRef.current) === null || _a === void 0 ? void 0 : _a.reset(lockExpiration);
        }
    }, [lockExpiration, enabledEntityLocking]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.header, "data-cy": "EAS__DETAIL_TOOLBAR" },
            react_1.default.createElement(Typography_1.default, { variant: "h1", className: classes.title },
                titleText,
                " ",
                react_1.default.createElement("span", { className: classes.subTitle }, subtitleText)),
            react_1.default.createElement("div", { className: classes.toolbarWrapper },
                react_1.default.createElement("div", { className: classes.toolbar },
                    !!Before && react_1.default.createElement(Before, null),
                    react_1.default.createElement("div", { id: "detail-toolbar" }),
                    react_1.default.createElement(AddButton, null),
                    showRefresh && (react_1.default.createElement(RefreshButtonComponent, { startIcon: react_1.default.createElement(Refresh_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__REFRESH", defaultMessage: "Obnovit" }), disabled: disabledRefresh, onClick: refresh })),
                    showShare && (react_1.default.createElement(ShareButtonComponent, { startIcon: react_1.default.createElement(Share_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__SHARE", defaultMessage: "Sd\u00EDlet" }), disabled: disabledShare, onClick: handleShare })),
                    showEdit && (react_1.default.createElement(EditButtonComponent, { startIcon: react_1.default.createElement(EditOutlined_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__EDIT", defaultMessage: "Upravit" }), disabled: disabledEdit, onClick: startEditing })),
                    showCheck && (react_1.default.createElement(CheckButtonComponent, { startIcon: react_1.default.createElement(PlaylistAddCheck_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__CHECK", defaultMessage: "Kontrola" }), disabled: disabledCheck, onClick: () => validate() })),
                    showSave && (react_1.default.createElement(SaveButtonComponent, { startIcon: react_1.default.createElement(Save_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__SAVE", defaultMessage: "Ulo\u017Eit" }), onClick: save, disabled: disabledSave, type: detail_types_1.DetailToolbarButtonType.PRIMARY })),
                    showClose && (react_1.default.createElement(CloseButtonComponent, { startIcon: react_1.default.createElement(Undo_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__CLOSE", defaultMessage: "Zru\u0161it" }), disabled: disabledClose, onClick: cancelEditing })),
                    showRemove && (react_1.default.createElement(RemoveButtonComponent, { startIcon: react_1.default.createElement(DeleteOutlined_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__REMOVE", defaultMessage: "Smazat" }), disabled: disabledRemove, onClick: handleDelete, type: detail_types_1.DetailToolbarButtonType.SECONDARY })),
                    showExport && (react_1.default.createElement(ExportButtonComponent, { startIcon: react_1.default.createElement(Print_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__EXPORT", defaultMessage: "Exportovat" }), disabled: disabledExport, onClick: openExportDialog })),
                    showUnlock && (react_1.default.createElement(detail_toolbar_button_2_1.DetailToolbarButton, { startIcon: react_1.default.createElement(LockOpen_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__UNLOCK", defaultMessage: "Odemknout" }), onClick: forceUnlockEntity, type: detail_types_1.DetailToolbarButtonType.SECONDARY })),
                    !!After && react_1.default.createElement(After, null),
                    isLocked && (react_1.default.createElement("div", { className: classes.lockIcon, "data-cy": "EAS__DETAIL_TOOLBAR__LOCK_BTN" },
                        react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__LOCK", defaultMessage: "Z\u00E1znam je uzam\u010Den, nen\u00ED mo\u017En\u00E9 jej d\u00E1le editovat." }) },
                            react_1.default.createElement(Lock_1.default, { fontSize: "large", color: "secondary" })))),
                    isLockedByAnotherUser && (react_1.default.createElement("div", { className: classes.lockIcon, "data-cy": "EAS__DETAIL_TOOLBAR__LOCKED_BY_ANOTHER_USER_BTN" },
                        react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__LOCKED_BY_ANOTHER_USER", defaultMessage: "Z\u00E1znam je aktu\u00E1ln\u011B editov\u00E1n jin\u00FDm u\u017Eivatelem." }) },
                            react_1.default.createElement(Person_1.default, { fontSize: "large", color: "secondary" })))),
                    isLockedByMe && (react_1.default.createElement("div", { className: classes.lockIcon, "data-cy": "EAS__DETAIL_TOOLBAR__LOCKED_BY_ME" },
                        react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__LOCKED_BY_ME", defaultMessage: "Z\u00E1znam je aktu\u00E1ln\u011B editov\u00E1n v jin\u00E9m okn\u011B." }) },
                            react_1.default.createElement(Person_1.default, { fontSize: "large", color: "primary" }))))),
                showCountdown && (react_1.default.createElement(countdown_1.Countdown, { ref: countdownRef, tooltipTitle: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DETAIL_TOOLBAR__COUNTDOWN", defaultMessage: "Zb\u00FDvaj\u00EDc\u00ED \u010Das pro editaci z\u00E1znamu. Po vypr\u0161en\u00ED nebudou zm\u011Bny ulo\u017Eeny." }), After: () => (react_1.default.createElement(IconButton_1.default, { onClick: keepLockAlive },
                        react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__DETAIL_TOOLBAR__COUNTDOWN_TOOLTIP", defaultMessage: "Prodlou\u017Eit \u010Das" }) },
                            react_1.default.createElement(Update_1.default, null)))), notifyChange: (duration) => {
                        if (duration === expirationReminderTime) {
                            remindLockExpiration === null || remindLockExpiration === void 0 ? void 0 : remindLockExpiration();
                        }
                    } }))),
            !!ActionBar && (react_1.default.createElement("div", { className: classes.actionbarWrapper },
                react_1.default.createElement(ActionBar, null)))),
        react_1.default.createElement(confirm_dialog_1.ConfirmDialog, { ref: confirmDeleteDialog, onConfirm: del, onCancel: lodash_1.noop, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__DIALOG_CONFIRM__TITLE", defaultMessage: "Varov\u00E1n\u00ED" }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__DIALOG_CONFIRM__TEXT", defaultMessage: "Opravdu chcete smazat z\u00E1znam?" }) }),
        react_1.default.createElement(share_dialog_1.ShareDialog, { ref: shareDeleteDialog, onCancel: lodash_1.noop })));
}
exports.DetailToolbar = DetailToolbar;
//# sourceMappingURL=detail-toolbar-2.js.map